$(document).ready(function () {
  console.log('hi from h.js');
  $('#stamped-reviews-widget .stamped-carousel-title').html('Real Customer Reviews');

  var currentSwatch = $('#add-to-cart-bar .single-option-selector').val();
  var swatchHeader = 'Color: <span class="swatch-value">' + currentSwatch + '</span>';
  $('#add-to-cart-bar .swatch .header').html(swatchHeader);
  $('#add-to-cart-bar .swatch-element input').on('click', function (el) {

    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    console.log('optionIndex', optionIndex);
    console.log('optionValue', optionValue);
    var swatchHeader = 'Color: <span class="swatch-value">' + optionValue + '</span>';
    $('#add-to-cart-bar .swatch .header').html(swatchHeader);
    $('.productForm .header__value').html(optionValue);
    $(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
    $('.product-info__wrapper form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
  });
  $('.nav-right .menu-item--meganav').on('mouseover', function () {
    console.log('right mega hover');
    console.log($(this).offset().left);
    console.log($(this).outerWidth());
    console.log(window.innerWidth);
    var rightDistance = window.innerWidth - $(this).offset().left - $(this).outerWidth();
    var marginValue = rightDistance + "px"
    console.log(rightDistance);
    $('.nav-right .positioned-submenu').css('margin-right', marginValue);
  });

  $('.lifestyle-row .fc-item .fc-field').each(function () {
    var theImg = $(this).find('img');
    var theUrl = theImg.attr('src');
    var bgCss = 'url("' + theUrl + '")'
    console.log(theUrl);
    $(this).css('background-image', bgCss);
  });
  $('.product-tab-content a').each(function () {
    var thisUrl = $(this).attr('href');
    if (thisUrl.indexOf('.jpg') > 0 || thisUrl.indexOf('.JPG') > 0 || thisUrl.indexOf('.JPEG') > 0 || thisUrl.indexOf('.jpeg') > 0 || thisUrl.indexOf('.PNG') > 0 || thisUrl.indexOf('.png') > 0) {
      $(this).addClass('product-tab-lightbox-link');
      $(this).magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        mainClass: 'mfp-img-mobile',
        image: {
          verticalFit: true
        }
      });
    }
  });

  $('.product-tab-content .product-tab-lightbox-link').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    mainClass: 'mfp-img-mobile',
    image: {
      verticalFit: true
    }
  });

});